import { render, staticRenderFns } from "./BookCardPopUp.vue?vue&type=template&id=4cb4c187"
import script from "./BookCardPopUp.vue?vue&type=script&lang=js"
export * from "./BookCardPopUp.vue?vue&type=script&lang=js"
import style0 from "./BookCardPopUp.vue?vue&type=style&index=0&id=4cb4c187&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports